module.exports = __webpack_public_path__ + "img/June--Hedera-Logo.49623c86.png";